<template>
<div class="bouts">
    <!-- <marquee-text :repeat="3">
        <div class="bout-roller">
            <p class="bout" v-for="bout in $store.state.allaPosterData.slice(0, 4)" v-bind:key="bout.id">
                <span :class="{ 'winner' : bout.debaters['1'].voteCount > bout.debaters['2'].voteCount}">
                    <span class="name">{{bout.debaters['1'].name}}</span><span class="score">&nbsp;{{bout.debaters['1'].voteCount}}</span>
                </span>
                <span class="vs">&nbsp;vs&nbsp;</span>
                <span :class="{ 'winner' : bout.debaters['2'].voteCount > bout.debaters['1'].voteCount}">
                    <span class="score">{{bout.debaters['2'].voteCount}}&nbsp;</span><span class="name">{{bout.debaters['2'].name}}</span>
                </span>
            </p>
        </div>
    </marquee-text> -->

    <div class="bout-roller">
        <marquee-text :repeat="6" v-for="(bout, index) in posts" :key="index">
        <!-- Den här måste ha en :key för att det ska fungera av någon oklar jävla anledning -->
            <BoutsList/>
            <!-- Den här är i en komponent för att jag får det inte att fungera med en till v-for här -->
        </marquee-text>
    </div>
    
</div>
</template>

<script>
import MarqueeText from 'vue-marquee-text-component'
import BoutsList from '@/components/BoutsList.vue'

export default {
    name: 'Bouts',
    props: [
        "posts"
    ],
    components: {
        MarqueeText,
        BoutsList
    },
    // computed: {
    //     bouts() {
    //         return this.$store.state.allaPosterData
    //     }
    // },
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";
.bouts {
    background-color: $black;
    height: $nav-height;
    overflow:hidden;
    display: flex;
    align-items: center;
    .bout-roller {
        display: flex;
        .bout {
            margin: 0 $icon-margin;
            white-space: nowrap;
            .name {
                color: $white;
            }
            .score {
                color: rgba(255, 255, 255, .5);
            }
            .vs {
                color: rgba(255, 255, 255, .5);
            }
            .winner {
                .name {
                    color: $white;
                }
                .score {
                    color: $icon-hover-color;
                }
            }
        }
    }
    
}
</style>
